// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import organisationRepresentativeEntity from './entities/organisation-representative.json';
import organisationRepresentativeMenu from '../pages/organisation-representative/menu.json';
import organisationRepresentativeFullForm from '../pages/organisation-representative/forms/full.json';
import organisationRepresentativeContextForm from '../pages/organisation-representative/forms/context.json';
import organisationRepresentativeMiniForm from '../pages/organisation-representative/forms/mini.json';
import organisationRepresentativeLookupForm from '../pages/organisation-representative/forms/lookup.json';
import organisationRepresentativeTableView from '../pages/organisation-representative/views/table.json';
import organisationRepresentativeCardsView from '../pages/organisation-representative/views/cards.json';
import organisationRepresentativeDashboardView from '../pages/organisation-representative/views/dashboard.json';

/** Тип запису «Представник організації» зі сторінками пакета: меню, форми та подання з pages/organisation-representative/. */
export const organisationRepresentativeDefinition: IRecordTypeDefinition = {
  ...organisationRepresentativeEntity,
  views: assembleViewSet({
      table: organisationRepresentativeTableView,
      cards: organisationRepresentativeCardsView,
      dashboard: organisationRepresentativeDashboardView,
  }),
  form: organisationRepresentativeFullForm,
  forms: { full: organisationRepresentativeFullForm, context: organisationRepresentativeContextForm, mini: organisationRepresentativeMiniForm, lookup: organisationRepresentativeLookupForm },
  menu: organisationRepresentativeMenu,
} as IRecordTypeDefinition;
